import { useEffect, useState } from 'react';

/**
 * Hook to get offsetHeight and offsetWidth
 * @param {Ref} ref
 * @returns {object{width: number, height: number}} size
 */

const useSize = (ref) => {
  const [size, setSize] = useState();
  useEffect(() => {
    if (ref?.current) {
      setTimeout(
        setSize({
          height: ref.current.offsetHeight,
          width: ref.current.offsetWidth,
        })
      );
    }
  }, [ref?.current]);
  return size;
};

export default useSize;
